import React from "react";
import CustomTooltip from "../CustomTooltip/CustomTooltip";
import {Box} from "@mui/material";

/**
 * Return the Group info validating if and is a single or array of groups
 * @param groupInfo {object} The information of the versus group.
 * @return JSX.Element
 */
function GroupDisplay({groupData}) {
    let display = groupData.groupInfo?.label;
    let info = groupData.groupInfo;
    let type = groupData.groupType?.label

    if(info?.length === 1) {
        display = info[0].label
    }

    if(info?.length > 1) {
        let typePlural =  type === 'County' ? 'Counties' : 'Districts';
        let groupLength = info.length;
        let groupsMap = info.map( (group, i) => <li key={i}>{group.label}</li>)

        display = <>{groupLength} {typePlural} <CustomTooltip text={<ul>{groupsMap}</ul>}/></>
    }

    return  (
        <Box component="span" className={'group-display'}>
            {display}
        </Box>
    )

}

export default React.memo(GroupDisplay);